import { LessonsListPageContent } from "@app/grades/pages";
import { getAllLessonsService } from "@core/grades/services/lessons.service";
import { type Lesson } from "@core/grades/types";
import { type PaginationInfo } from "@core/shared/types";
import { URLS } from "@core/shared/utils/urls";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { MetaFunction } from "@remix-run/node";
import { publicRoutes } from "@framework/middleware";
import { plainTrans } from "@mongez/localization";
import { useLoaderData } from "@remix-run/react";

export const loader = publicRoutes(async ({ request, http, success, redirectTo }) => {
  const url = new URL(request.url);
  const page = parseInt(url.searchParams.get("page") || "1");
  const limit = parseInt(url.searchParams.get("limit") || "16");
  const search = url.searchParams.get("search") || "";
  const grade = url.searchParams.get("grade") || "";
  const category = url.searchParams.get("category") || "";

  const params = {
    page,
    limit,
    ...(search && { name: search }),
    ...(grade && { grade }),
    ...(category && { category }),
  };

  const data = await getAllLessonsService(http, params);
 
  // Check if lessons is not an array and redirect to 404
  if (!Array.isArray(data?.lessons)) {
    return redirectTo(URLS.notFound);
  }
  
  return success(data);
});

export default function LessonsIndex() {
  const { lessons, paginationInfo } = useLoaderData<{
    lessons: Lesson[];
    paginationInfo: PaginationInfo;
  }>();

  return (
    <LessonsListPageContent lessons={lessons} paginationInfo={paginationInfo} />
  );
}

export const meta: MetaFunction = ({ matches }) => {
  const settings = getRootSettings(matches);

  return pageHead({
    title: `${plainTrans("grades.lessons")} - ${settings.general?.appName || ""}`,
    description: plainTrans("grades.lessonsDescription"),
    image: settings.general?.logo?.url || "",
    settings,
  });
};
